import { OfferDto, UpdateOfferRequest } from '@generatedTypes/data-contracts';

export const parseOfferForUpdate = (offer: OfferDto): UpdateOfferRequest => ({
  introText: offer.introText,
  offerSenderId: offer.sender?.id,
  numberOfDaysBeforeExpiry: offer.numberOfDaysBeforeExpiry,
});
